var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.languageList)?_c('c-select',{attrs:{"prepend-inner-icon":"capsule-globe","items":_vm.languageList,"menu-props":{
    bottom: true,
    contentClass: 'elevation-large border-menu',
    maxHeight: 255,
    nudgeBottom: 16,
    offsetY: true,
    rounded: true,
  }},scopedSlots:_vm._u([(_vm.$slots.label)?{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}:null],null,true),model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }